import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonItemOption, IonItemOptions, IonItemSliding, IonLabel, IonModal, IonTitle, IonToolbar } from '@ionic/react'
import { closeOutline, createOutline, trashOutline } from 'ionicons/icons'
import { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { startEquipoUpdated } from '../../../actions/equipos'
import { setActiveLoading, setFrecuenciaEditHide, setFrecuenciaEditShow } from '../../../actions/ui'
import { RootState } from '../../../reducers/rootReducer'

const initForm = {
  frecuencia: '',
}

export const FrecuenciaItem: FC = () => {
  const dispatch = useDispatch();
  const { activeEquipo: { frecuencia } } = useSelector((state: RootState) => state.equipo);
  const { editFrecuencia } = useSelector((state: RootState) => state.ui);

  const handleDelete = () => {}
  const handleUpdate = () => {
    dispatch(setFrecuenciaEditShow())

  }
  return (
    <IonItem>
      <IonLabel className="item-label" position="stacked" color="primary">
        Frecuencia
      </IonLabel>
      <IonItemSliding>
        <IonItem lines="none">
          <IonLabel>{frecuencia}</IonLabel>
          {editFrecuencia && <FrecuenciaModal />}
        </IonItem>
        <IonItemOptions side="end" color="light">
          <IonItemOption color="light" onClick={() => { handleUpdate() }}><IonIcon className="icon-list" color="success" ariaLabel="Editar" title="Editar" icon={createOutline}></IonIcon></IonItemOption>
          <IonItemOption color="light" onClick={() => { handleDelete() }}><IonIcon className="icon-list" color="danger" icon={trashOutline}></IonIcon></IonItemOption>
        </IonItemOptions>
      </IonItemSliding>
    </IonItem>
  )
}

const FrecuenciaModal: FC = () => {
  const dispatch = useDispatch();

  const { editFrecuencia } = useSelector((state: RootState) => state.ui);
  const { activeEquipo } = useSelector((state: RootState) => state.equipo);

  const [formValues, setFormValues] = useState(initForm);
  const { frecuencia } = formValues;
  useEffect(() => {
    if (activeEquipo.frecuencia) {
      const f = {
        frecuencia: activeEquipo.frecuencia,
      };
      setFormValues(f)
    } else {
      setFormValues(initForm)
    }
  }, [activeEquipo.frecuencia])

  const handleInputChange = ({ target }) => {
    setFormValues({
      ...formValues,
      [target.name]: target.value,
    });
  };

  const equipo = {
    tag: activeEquipo.tag,
    nombre_equipo: activeEquipo.nombre_equipo,
    descripcion_equipo: activeEquipo.descripcion_equipo,
    central: activeEquipo.central !== null ? activeEquipo.central._id : "",
    numero_equipo: activeEquipo.numero_equipo,
    type: activeEquipo.type,
    frecuencia: activeEquipo.frecuencia,

  };

  const handleUpdate = (e: any) => {
    e.preventDefault();
    dispatch(setActiveLoading());
    equipo.frecuencia = frecuencia
    dispatch(startEquipoUpdated(equipo));
    dispatch(setFrecuenciaEditHide())
  };

  const handleClose = () => {
    dispatch(setFrecuenciaEditHide());
  };
  return (
    <IonContent>
      <IonModal isOpen={editFrecuencia} cssClass='modal-unit-iput'>
        <IonHeader className="ion-no-border">
          <IonToolbar>
            <IonTitle color="dark">Frecuencia</IonTitle>
            <IonButtons slot="end">
              <IonButton color="primary" onClick={handleClose}>
                <IonIcon icon={closeOutline}></IonIcon>
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent className="marca-container">
          <form onSubmit={handleUpdate}>
            <IonItem lines="inset">
              <IonInput
                type="text"
                inputMode="decimal"
                name="frecuencia"
                value={frecuencia}
                onIonChange={handleInputChange}
                placeholder="Frecuencia"
              ></IonInput>
            </IonItem>
            <IonItem lines="none">
              <IonButton slot="end" fill="clear" type="submit">
                Guardar
              </IonButton>
              <IonButton slot="end" fill="clear" onClick={handleClose}>
                Cancelar
              </IonButton>
            </IonItem>          
          </form>
        </IonContent>
      </IonModal>
    </IonContent>
  );
}

